// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2OJyq","location":"Header_location__3aZMT"};